const timeouts = {}

export const headerTabLinking = (error) => {
    clearTimeouts(timeouts)
    if (error?.listType && error?.fieldId) {
        timeouts.headerRepElem = setTimeout(() => {
            const headerTabField = document.getElementById(`${error?.fieldName}-${error?.fieldId}`)
            headerTabField && focusDomElement(headerTabField)
        }, 300)
    } else {
        timeouts.header = setTimeout(() => {
            const headerTabField = document.getElementById(`${error?.fieldName}`)
            headerTabField && focusDomElement(headerTabField)
        }, 300)
    }
}

export const partiesTabLinking = (error) => {
    clearTimeouts(timeouts)
    if (error?.partyType) {
        partyFieldLinking(error)
    } else {
        timeouts.partiesInput = setTimeout(() => {
            const partyInputElement = document.getElementById(`${error?.fieldName}`)
            partyInputElement && focusDomElement(partyInputElement)
        }, 200)
    }
}

export const containersTabLinking = () => {

    
}

export const itemsTabLinking = (error) => {
    clearTimeouts(timeouts)
    if (!error?.invoiceId && !error?.merchandiseId && !error?.listType && !error.fieldId) {
        timeouts.invoiceTabHeader = setTimeout(() => {
            const invoiceFieldHeader = document.getElementById(`${error?.fieldName}`)
            invoiceFieldHeader && focusDomElement(invoiceFieldHeader)
        }, 500)
    } else {
        timeouts.invoiceTab = setTimeout(() => {
            const invoiceToggleLink = document.getElementById(`inActive-expandCollapseInvoice-${error?.invoiceId}`)
            if (invoiceToggleLink) invoiceToggleLink?.click()

            if (error?.invoiceId && !error?.merchandiseId) {
                if (error?.listType && error?.listType === "invoiceParties") {
                    itemLevelParties(error)
                } else {
                    timeouts.invoiceField = setTimeout(() => {
                        const invoiceFieldElement = document.getElementById(`${error?.invoiceId}-${error?.fieldName}`)
                        invoiceFieldElement && focusDomElement(invoiceFieldElement)
                    }, 500)
                }
            } else if (error?.invoiceId && error?.merchandiseId) {
                timeouts.merchToggle = setTimeout(() => {
                    const merchToggleLink = document.getElementById(`inActive-expandCollapseMerch-${error?.merchandiseId}`)
                    if (merchToggleLink) merchToggleLink.click()

                    if (error?.listType === "packagesList") { // condition to call itemsTabPopup
                        itemsTabPopup(error)
                    } else {
                        if (error?.invoiceId && error?.merchandiseId && error?.fieldId) {
                            timeouts.repElemField = setTimeout(() => {
                                const repElementField = document.getElementById(`${error?.fieldName}-${error?.fieldId}`)
                                repElementField && focusDomElement(repElementField)
                            }, 200)
                        } else if (error?.invoiceId && error?.merchandiseId && !error?.fieldId) {
                            timeouts.merchField = setTimeout(() => {
                                const merchFieldElement = document.getElementById(`${error?.fieldName}-${error?.invoiceId}-${error?.merchandiseId}`)
                                merchFieldElement && focusDomElement(merchFieldElement)
                            }, 200)
                        }
                    }

                }, 300)
            }
        }, 300)
    }
}



// EU Country tabs start
export const headerTabEULinking = (error) => {
    clearTimeouts(timeouts)
    if (error?.partyType) {
        timeouts.headerTabParties = setTimeout(() => {
            const headerTabPartiesToggle = document.getElementById(`inActive-${error?.partyType}`)
            if (headerTabPartiesToggle) headerTabPartiesToggle?.click()
            timeouts.headerTabPartyField = setTimeout(() => {
                const headerTabPartyField = document.getElementById(`${error?.fieldName}-${error?.partyType}-${error?.fieldId}`)
                headerTabPartyField && focusDomElement(headerTabPartyField)
            }, 500)
        }, 300)
    } else { headerTabLinking(error) }
}

export const transportTabEULinking = (error) => {
    clearTimeouts(timeouts)
    if (error?.listType && error?.fieldId && error?.fieldName) {
        timeouts.transportTabListField = setTimeout(() => {
            const domElementField = document.getElementById(`${error?.listType}-${error?.fieldId}-${error?.fieldName}`)
            domElementField && focusDomElement(domElementField)
        }, 300)
    } else if (error?.listType && !error?.fieldId && !error?.fieldName) {
        timeouts.transportTabList = setTimeout(() => {
            const domElementList = document.getElementById(`${error?.listType}`)
            domElementList && highlightDomElement(domElementList)
        }, 300)
    } else {
        timeouts.transportTab = setTimeout(() => {
            const transportTabField = document.getElementById(`${error?.fieldName}`)
            transportTabField && focusDomElement(transportTabField)
        }, 300)
    }
}

function itemsTabPopup(error) {
    // clearTimeouts(timeouts)
    if (error?.invoiceId && error?.merchandiseId && !error?.fieldId) {
        timeouts.repElemFieldToBeHighlight = setTimeout(() => {
            const domElement = document.getElementById(`${error?.listType}.toBeHighlight-${error?.invoiceId}-${error?.merchandiseId}`)
            domElement && highlightDomElement(domElement)
            // domElement && focusDomElement(domElement)
        }, 200)
    } else if (error?.invoiceId && error?.merchandiseId && error?.fieldId) {
        const merchDocModal = document.getElementById(`packagesList-${error?.invoiceId}-${error?.merchandiseId}`)
        merchDocModal && merchDocModal.click()
        timeouts.repElemField = setTimeout(() => {
            const repElementField = document.getElementById(`${error?.fieldName}-${error?.fieldId}`)
            repElementField && focusDomElement(repElementField)
        }, 200)
    }
}
// EU Country tabs end

// item level parties start
function itemLevelParties(error) {
    const invoicePartiesToggle = document.getElementById(`inActive-expandCollapseInvoiceParties-${error?.invoiceId}`)
    if (invoicePartiesToggle) invoicePartiesToggle?.click()
    partyFieldLinking(error)
}
// item level parties end


function partyFieldLinking(error) {
    let invoiceId = error?.invoiceId || ''
    timeouts.partiesTab = setTimeout(() => {
        const partyTypeToggle = document.getElementById(`inActive-${error?.partyType}`)
        if (partyTypeToggle) partyTypeToggle?.click()
        timeouts.partiesActor = setTimeout(() => {
            const partyActorInputElement = document.getElementById(`${error?.partyType}${error?.fieldName}${invoiceId}`)
            partyActorInputElement && focusDomElement(partyActorInputElement)
        }, 200)
    }, 300)
}

function focusDomElement(domElement) {
    domElement && domElement?.focus() || domElement?.click()
    domElement && highlightDomElement(domElement)
}

function highlightDomElement(domElement) {
    domElement.setAttribute('style', domElement.getAttribute('style') + '; background-color:#FFFF00 !important');
    domElement.style.transition = 'all 750ms ease-out';
    timeouts.domElement = domElement
    timeouts.highlight = setTimeout(function () {
        domElement.style.backgroundColor = '';
    }, 1500);
}

function clearTimeouts(timeouts) {
    Object.keys(timeouts).map(e => {
        if (`${e}` == 'domElement') {
            timeouts[e].style.backgroundColor = ''
        }
        clearTimeout(timeouts[e])
    })
}